// Admin — archive of the Monday weekly platform ops reports.
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { FileText, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import AdminLayout from './AdminLayout';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminWeeklyReportsPage() {
  const [reports, setReports] = useState(null);
  const [selected, setSelected] = useState(null);
  const [loadingReport, setLoadingReport] = useState(false);

  useEffect(() => {
    axios.get(`${API}/admin/weekly-reports`)
      .then((r) => setReports(r.data.reports || []))
      .catch(() => toast.error('Could not load reports'));
  }, []);

  const open = async (id) => {
    setLoadingReport(true);
    try {
      const r = await axios.get(`${API}/admin/weekly-reports/${id}`);
      setSelected(r.data);
    } catch {
      toast.error('Could not load report');
    }
    setLoadingReport(false);
  };

  const fmt = (iso) => new Date(iso).toLocaleDateString([], { day: 'numeric', month: 'short', year: 'numeric' });

  return (
    <AdminLayout title="Weekly Reports">
      <div className="grid lg:grid-cols-[320px_1fr] gap-4" data-testid="weekly-reports-page">
        <div className="bg-white/[0.03] border border-white/10 rounded-xl p-4">
          <h2 className="text-white font-bold text-sm mb-3 flex items-center gap-2">
            <FileText className="w-4 h-4 text-teal-300" /> Past weekly ops reports
          </h2>
          {reports === null ? (
            <Loader2 className="w-5 h-5 text-white/40 animate-spin" />
          ) : reports.length === 0 ? (
            <p className="text-white/40 text-xs italic">No reports yet — the first one sends Monday 7:00am AEST.</p>
          ) : (
            <div className="space-y-1.5">
              {reports.map((r) => (
                <button key={r.id} onClick={() => open(r.id)}
                  className={`w-full text-left rounded-lg px-3 py-2.5 border transition-colors ${selected?.id === r.id ? 'border-teal-400/40 bg-teal-500/10' : 'border-white/10 hover:bg-white/5'}`}
                  data-testid={`weekly-report-${r.id}`}>
                  <p className="text-white text-sm font-semibold">Week ending {fmt(r.ts)}</p>
                  <p className="text-white/40 text-[11px] mt-0.5">
                    Queue: {r.queue?.waiting ?? '—'} waiting · Uptime: {r.gymsales?.has_data ? `${r.gymsales.uptime_pct}%` : 'n/a'} · Heals: {r.queue?.heal_removed ?? 0}
                  </p>
                </button>
              ))}
            </div>
          )}
        </div>
        <div className="bg-white border border-white/10 rounded-xl p-6 min-h-[300px]" data-testid="weekly-report-view">
          {loadingReport ? (
            <div className="flex justify-center py-16"><Loader2 className="w-6 h-6 text-slate-400 animate-spin" /></div>
          ) : selected ? (
            <div dangerouslySetInnerHTML={{ __html: selected.html }} />
          ) : (
            <p className="text-slate-400 text-sm italic p-4">Select a report on the left to view it.</p>
          )}
        </div>
      </div>
    </AdminLayout>
  );
}
